const formatNumber = (num: (number | string), thus_sep?: string) => {
    if(typeof thus_sep == "undefined"){
        thus_sep = '\'';
    }
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thus_sep)
}

export default formatNumber;